import { render, staticRenderFns } from "./reconMatching.vue?vue&type=template&id=58a0d900&scoped=true"
import script from "./reconMatching.vue?vue&type=script&lang=js"
export * from "./reconMatching.vue?vue&type=script&lang=js"
import style0 from "./reconMatching.vue?vue&type=style&index=0&id=58a0d900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a0d900",
  null
  
)

export default component.exports